import type { IRestModel } from "@nkr/utils/rest-api";
import { RestApi } from "@nkr/utils/rest-api";
import { LookupApi } from "@nkr/utils/rest-api/LookupApi";

export interface IVoucherBookStatus extends IRestModel {
    id               : number | string,
    hasJob          ?: boolean,
    lastRunDateTime ?: string,
    lastRunStatus   ?: string,
    percentComplete ?: string,
    percentValue    ?: number
}

export interface IVoucherBookInfo extends IRestModel {
    id                 : number | string,
    generatedDateTime ?: string,
    isAvailable       ?: boolean
}

export const useVoucherBookBackgroundTask = () => {
    const statusLookup  = new LookupApi<IVoucherBookStatus>(`${__API__}/admin/voucher-book/status`);
    const statusHooks   = statusLookup.makeHooks();
    const infoLookup    = new LookupApi<IVoucherBookInfo>(`${__API__}/admin/voucher-book/info`);
    const infoHooks     = infoLookup.makeHooks();
    const instance      = new RestApi<IVoucherBookStatus, IVoucherBookStatus>(`${__API__}/admin/voucher-book`);
    const hooks         = instance.makeHooks();
    const create        = hooks.useCreate();
    return {
        useStatus       : statusHooks.useGetData,
        refreshStatus   : statusHooks.refresh,
        useInfo         : infoHooks.useGetData,
        refreshInfo     : infoHooks.refresh,
        initiate        : create.submit
    }
};
